import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { ShortcutService } from '../shortcut.service';

@Component({
  selector: 'app-draft-team-header',
  templateUrl: './draft-team-header.component.html',
  styleUrls: ['./draft-team-header.component.scss']
})
export class DraftTeamHeaderComponent implements OnInit {

  /** @var {ElementRef} container['nativeElement'] grants referenece to the HTMLElement of this component's container */
  @ViewChild('container', {static: false}) container: ElementRef;
  /** @var {string} Color of this team */
  @Input('team') team: string;
  /** @var {string} Name of this team */
  public name = "Team X";
  /** @var {string[]} List of champion IDs that are banned */
  public bans = [null, null, null, null, null];

  constructor(
    private shortcutService: ShortcutService
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.container.nativeElement.classList.add(this.team);
  }

  handleOnFocus() {
    this.shortcutService.enabled = false;
  }

  handleOnBlur() {
    this.shortcutService.enabled = true;
    console.log(this.shortcutService.enabled)
  }

}
